import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { Sheet, SheetContent, SheetTitle } from "../sheet";
import { SidebarDrawerContext } from "./SidebarDrawerContext";
import { useSidebar } from "./useSidebar";

// Боковое меню: на компьютере — колонка слева, закреплена при прокрутке и сворачивается
// до значков; на телефоне то же содержимое выезжает шторкой. Вид частей меню в свёрнутом
// состоянии задают классы `group-data-[state=collapsed]/sidebar:`; в шторке такой группы
// нет, поэтому там меню всегда развёрнуто.
export const Sidebar = ({ className, children, ...props }: ComponentProps<"div">) => {
  const { _ } = useLingui();
  const { state, openMobile, setOpenMobile } = useSidebar();
  return (
    <>
      <div
        data-slot="sidebar"
        data-state={state}
        className={cn(
          "group/sidebar sticky top-0 hidden h-dvh shrink-0 flex-col border-r border-border bg-sidebar transition-[width] duration-200 ease-linear md:flex",
          state === "expanded" ? "w-64" : "w-19",
          className,
        )}
        {...props}
      >
        {children}
      </div>
      <Sheet open={openMobile} onOpenChange={setOpenMobile}>
        <SheetContent
          side="left"
          showCloseButton={false}
          aria-describedby={undefined}
          className="w-76 max-w-[85vw] bg-sidebar md:hidden"
          // Переход по любой ссылке в шторке закрывает её: под ней уже другая страница.
          onClickCapture={(event) => {
            if (event.target instanceof Element && event.target.closest("a[href]") !== null) {
              setOpenMobile(false);
            }
          }}
        >
          <SheetTitle className="sr-only">{_(msg`Menu`)}</SheetTitle>
          <SidebarDrawerContext.Provider value={true}>{children}</SidebarDrawerContext.Provider>
        </SheetContent>
      </Sheet>
    </>
  );
};
